/* BADL theme: vanilla JS, no dependencies.
   Everything is event-delegated so it keeps working after the theme editor re-renders a section. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.BADL || {};

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(t) {
    var el = $('#toast'); if (!el) return;
    el.textContent = t; el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  /* ---------- overlays ---------- */
  function openCart() { var c = $('#cart'); if (c) c.classList.add('open'); }
  function closeAll() { ['cart', 'search', 'lightbox', 'drawerNav'].forEach(function (id) { var el = document.getElementById(id); if (el) el.classList.remove('open'); }); }

  /* ---------- cart ---------- */
  function refreshCart(open) {
    return fetch(CFG.cartUrl + (CFG.cartUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('#cart', doc), cur = $('#cart');
        if (!fresh || !cur) return;
        $('.panel', cur).innerHTML = $('.panel', fresh).innerHTML;
        var n = parseInt(fresh.getAttribute('data-count'), 10) || 0;
        cur.setAttribute('data-count', n);
        var badge = $('#cartCount');
        if (badge) { badge.textContent = n; badge.hidden = !n; }
        if (open) openCart();
      });
  }
  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not update the cart'); return j; });
    });
  }

  /* ---------- hero ---------- */
  function initHero(hero) {
    var slides = $$('.slide', hero), dots = $$('[data-dots] button', hero), count = $('[data-count]', hero), pauseBtn = $('[data-pause]', hero);
    if (slides.length < 2) return;
    var i = 0, paused = false, timer = null, DUR = 6000;
    hero.style.setProperty('--dur', DUR + 'ms');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function restart() { clearInterval(timer); if (!paused) timer = setInterval(function () { go(i + 1); }, DUR); }
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.remove('on'); void d.offsetWidth; d.classList.toggle('on', k === i); });
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      restart();
    }
    var prev = $('[data-prev]', hero), next = $('[data-next]', hero);
    if (prev) prev.onclick = function () { go(i - 1); };
    if (next) next.onclick = function () { go(i + 1); };
    dots.forEach(function (d, k) { d.onclick = function () { go(k); }; });
    function setPaused(p) {
      paused = p; hero.classList.toggle('paused', p);
      if (pauseBtn) { pauseBtn.textContent = p ? '▶' : '❚❚'; pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow'); }
      restart();
    }
    if (pauseBtn) pauseBtn.onclick = function () { setPaused(!paused); };
    hero.onmouseenter = function () { hero.classList.add('paused'); clearInterval(timer); };
    hero.onmouseleave = function () { if (!paused) { hero.classList.remove('paused'); restart(); } };
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    document.addEventListener('keydown', function (e) {
      if (!document.body.contains(hero)) return;
      if (e.key === 'ArrowRight') go(i + 1);
      if (e.key === 'ArrowLeft') go(i - 1);
    });
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) setPaused(true); else restart();
  }

  /* ---------- product page ---------- */
  function sized(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function initPDP(root) {
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var colorPills = $$('#colorPills .pill', root), sizePills = $$('.pill.size', root);
    var hasSize = product.options.length > 1;
    var ci = 0, size = null;
    var colorValues = colorPills.map(function (b) { return b.getAttribute('data-value'); });
    var form = $('#pdpForm', root), qty = $('#qty', root), mainImg = $('#mainImg', root);
    var idInput = form && form.querySelector('[name=id]');
    var color = function () { return colorValues.length ? colorValues[ci] : product.variants[0].option1; };

    function variant() {
      for (var k = 0; k < product.variants.length; k++) {
        var v = product.variants[k];
        if (v.option1 === color() && (!hasSize || v.option2 === size)) return v;
        if (colorValues.length === 0 && !hasSize) return v;
      }
      return null;
    }
    function updateStock() {
      sizePills.forEach(function (b) {
        var s = b.getAttribute('data-s');
        var ok = product.variants.some(function (v) { return v.option1 === color() && v.option2 === s && v.available; });
        b.disabled = !ok;
        if (!ok && size === s) { size = null; b.classList.remove('on'); var n = $('#sizeName', root); if (n) n.textContent = 'Choose a size'; }
      });
    }
    function setColor(k) {
      ci = k;
      var c = $('#colorName', root); if (c) c.textContent = colorValues[k] || '';
      colorPills.forEach(function (b, j) { b.classList.toggle('on', j === k); });
      $$('#thumbs button', root).forEach(function (b, j) { b.classList.toggle('on', j === k); });
      var v = product.variants.filter(function (x) { return x.option1 === color(); })[0];
      if (v && v.featured_image && mainImg) mainImg.src = sized(v.featured_image.src, 1400);
      updateStock();
      var w = $('#stockWarn', root); if (w) w.hidden = true;
    }
    colorPills.forEach(function (b) { b.onclick = function () { setColor(+b.getAttribute('data-i')); }; });
    $$('#thumbs button', root).forEach(function (b) {
      b.onclick = function () {
        var direct = b.getAttribute('data-src');
        if (direct && mainImg) { mainImg.src = direct; $$('#thumbs button', root).forEach(function (x) { x.classList.toggle('on', x === b); }); }
        else setColor(+b.getAttribute('data-i'));
      };
    });
    sizePills.forEach(function (b) {
      b.onclick = function () {
        size = b.getAttribute('data-s');
        sizePills.forEach(function (x) { x.classList.toggle('on', x === b); });
        var n = $('#sizeName', root); if (n) n.textContent = size;
        var w = $('#sizeWarn', root); if (w) w.hidden = true;
        var sw = $('#stockWarn', root); if (sw) sw.hidden = true;
      };
    });
    if (qty) {
      $('#qMinus', root).onclick = function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); };
      $('#qPlus', root).onclick = function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; };
    }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (hasSize && !size) { $('#sizeWarn', root).hidden = false; return; }
      var v = variant();
      if (!v || !v.available) { $('#stockWarn', root).hidden = false; return; }
      if (idInput) idInput.value = v.id;
      var btn = $('#addBtn', root); btn.disabled = true;
      cartRequest(CFG.cartAddUrl, { items: [{ id: v.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }] })
        .then(function () { return refreshCart(true); })
        .catch(function (err) { toast(err.message); })
        .then(function () { btn.disabled = false; });
    });
    updateStock();
  }

  /* ---------- collection filters / sort ---------- */
  function applyFilter(f) {
    $$('#shopGrid .card').forEach(function (c) {
      var a = $('[data-img-a]', c), b = $('[data-img-b]', c), badge = $('[data-badge]', c);
      if (a && !c.hasAttribute('data-orig')) { c.setAttribute('data-orig', '1'); c._oa = a.src; c._ob = b ? b.src : ''; c._ot = badge ? badge.textContent : ''; }
      if (f === 'all') { c.hidden = false; if (a) a.src = c._oa; if (b) b.src = c._ob; if (badge) badge.textContent = c._ot; return; }
      var k = f === 'black' ? 'b' : 'w', n = parseInt(c.getAttribute('data-' + k + 'n'), 10) || 0;
      if (!n) { c.hidden = true; return; }
      c.hidden = false;
      if (a) a.src = c.getAttribute('data-' + k + '1');
      if (b) b.src = c.getAttribute('data-' + k + '2') || c.getAttribute('data-' + k + '1');
      if (badge) badge.textContent = n + (n > 1 ? ' colorways' : ' colorway');
    });
  }

  /* ---------- search ---------- */
  var searchTimer;
  function doSearch() {
    var q = $('#searchInput').value.trim(), out = $('#searchResults');
    if (!q) { out.innerHTML = ''; return; }
    var url = CFG.searchUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var wrap = $('.shopify-section', doc);
      out.innerHTML = wrap ? wrap.innerHTML : doc.body.innerHTML;
    }).catch(function () { out.innerHTML = '<p class="note">Search is unavailable right now.</p>'; });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('#cartBtn'))) { e.preventDefault(); openCart(); refreshCart(false); return; }
    if ((el = t.closest('#menuBtn'))) { $('#drawerNav').classList.add('open'); return; }
    if ((el = t.closest('#searchBtn'))) { var s = $('#search'); s.classList.add('open'); $('#searchInput').value = ''; $('#searchResults').innerHTML = ''; $('#searchInput').focus(); return; }
    if (t.closest('#searchClose')) { $('#search').classList.remove('open'); return; }
    if ((el = t.closest('[data-close]'))) { var host = el.closest('.cart, .drawer-nav'); if (host) host.classList.remove('open'); return; }
    if ((el = t.closest('#drawerNav a'))) { $('#drawerNav').classList.remove('open'); return; }
    if ((el = t.closest('#searchResults a'))) { $('#search').classList.remove('open'); return; }
    if ((el = t.closest('.rm[data-line]'))) {
      el.disabled = true;
      cartRequest(CFG.cartChangeUrl, { line: parseInt(el.getAttribute('data-line'), 10), quantity: 0 })
        .then(function () { return refreshCart(false); })
        .catch(function (err) { toast(err.message); el.disabled = false; });
      return;
    }
    if ((el = t.closest('[data-lb]'))) { $('#lbImg').src = el.getAttribute('data-lb'); $('#lightbox').classList.add('open'); return; }
    if (t.closest('#lbClose') || t.id === 'lightbox') { $('#lightbox').classList.remove('open'); return; }
    if ((el = t.closest('#fChips .chip'))) {
      $$('#fChips .chip').forEach(function (c) { c.classList.toggle('on', c === el); });
      applyFilter(el.getAttribute('data-f')); return;
    }
    if (t.closest('#copyEmail')) {
      var email = CFG.email || ($('#emailTxt') && $('#emailTxt').textContent);
      var done = function () { toast('Email copied'); };
      var fallback = function () {
        var r = document.createRange(); r.selectNodeContents($('#emailTxt'));
        var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); toast('Email selected. Press copy.');
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(email).then(done).catch(fallback); else fallback();
    }
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('#sortSel');
    if (sel) location.href = sel.getAttribute('data-sort-url') + '?sort_by=' + encodeURIComponent(sel.value);
  });
  document.addEventListener('input', function (e) {
    if (e.target.id === 'searchInput') { clearTimeout(searchTimer); searchTimer = setTimeout(doSearch, 250); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- init ---------- */
  function init(root) {
    $$('[data-hero]', root).forEach(initHero);
    $$('[data-pdp]', root).forEach(initPDP);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(false); });
})();
